import { render, staticRenderFns } from "./WorkWeekDaysSetupView.vue?vue&type=template&id=6edb5bf8&scoped=true&"
import script from "./WorkWeekDaysSetupView.vue?vue&type=script&lang=ts&"
export * from "./WorkWeekDaysSetupView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edb5bf8",
  null
  
)

export default component.exports